import Spinner from '@/components/Spinner';

export function Wrapper(props) {
	return (
		<div
			className="w-full max-w-[94.5rem] md:mx-auto md:w-[calc(100vw-252px)]"
			{...props}
		/>
	);
}

export function Loader() {
	return <Spinner className="mx-auto mt-10" size={50} />;
}
